const config = {
	appVersionNumber: () => process.env.REACT_APP_VERSION_NUMBER || 'v100',
	privacyPolicyLink: () => process.env.REACT_APP_PRIVACY_POLICY_LINK || 'https://mondago.com/policies/?privacy-policy',
	apiUrl: () => process.env.REACT_APP_API_URL || 'https://licensing-portal-api.mondago.com',
	consumerTemplateUpdateUrl: () =>
		process.env.REACT_APP_CONSUMER_UPLOAD_TEMPLATE_URL || 'https://stcustomerportalstaging.blob.core.windows.net/template/example.csv',
	isPublicAPIManagementEnabled: () => (process.env.REACT_APP_ENABLE_PUBLIC_API_MANAGEMENT?.toLowerCase() === 'true' ? true : false)
}

export default config
